<script>
  import Page from 'page'
  import { api } from '../../store'
  let localapi
  api.subscribe((value) => {
    localapi = value
  })

  let fullName, age, skillsIntrest

  function validateForm() {
    let allValue = {
      fullName,
      age,
      skillsIntrest,
    }

    let error = ''

    for (const [key, value] of Object.entries(allValue)) {
      if (value === undefined) {
        error += `${key}\n`
        console.log(key)
      }
    }

    error == ''
      ? senddata(allValue)
      : alert(`Please fill the folowing fields \n${error}`)
  }

  let senddata = async (param) => {
    let loginDatum = JSON.parse(localStorage.getItem('loginData'))
    let mainid = JSON.parse(localStorage.getItem('loginData')).email
    let data = new FormData()
    data.append('fullName', param.fullName)
    data.append('age', param.age)
    data.append('skillsIntrest', param.skillsIntrest)
    data.append('mainid', mainid)

    let xhttp = new XMLHttpRequest()

    // xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        // Typical action to be performed when the document is ready:
        let result = JSON.parse(xhttp.responseText)
        console.log(result)

        if (result.error == false) {
          window.location.reload()
        } else {
          Page.redirect('/logout')
        }
      }
    }
    xhttp.open('POST', `${localapi}?url=createMemberkid`, true)
    xhttp.setRequestHeader('Authorization', `Bearer ${loginDatum.token}`)
    xhttp.send(data)
  }
</script>

<div class="login">
  <form on:submit|preventDefault="{validateForm}">
    <div>
      <h2 class="text-center">Add Kid</h2>
    </div>

    <div class="row">
      <div class="form-group  col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">Full Name</label>
        <input
          required
          type="text"
          class="form-control"
          bind:value="{fullName}" />
      </div>

      <div class="form-group  col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">Age</label>
        <input required type="number" class="form-control" bind:value="{age}" />
      </div>

      <div class="form-group  col-6 mb-3 mt-3">
        <label for="exampleInputEmail1">Skills / Interest</label>
        <input
          required
          type="text"
          class="form-control"
          bind:value="{skillsIntrest}" />
      </div>
    </div>

    <button type="submit" class="btn btn-primary">Submit</button>
  </form>
</div>

<style lang="scss">
  .login {
    padding: 10px;
    min-height: 80vh;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2vh;
    margin-bottom: 10vh;
    background-color: #fff;

    form {
      width: 100%;
      max-width: 500px;
    }
  }
</style>
